import React from 'react';
import properties from '../../constants/Properties';
import locales from '../../locales/LocalesManager';
import { changeContextMode, showExportAlert } from '../../actions/MenuActions';
import { updateCurrentSlide } from '../../actions/ProductionActions';
import modeType from '../../constants/ModeConstants';
import saveManager from '../utils/SaveManager';
import appParameters from '../utils/AppParameters';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import animationManager from '../utils/AnimationManager';
import storeManager from '../../store/StoreManager';

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        var titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        var spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        var closeButtonStyle = {
            position: 'absolute',
            width: 24,
            height: 24,
            top: 3,
            right: 28,
            cursor: 'pointer',
            borderStyle: 'none',
            background: 'none',
        };

        var closeStyle = {
            position: 'relative',
            width: 15,
            top: 2,
            left: -2
        };

        if (platformDetection.isIOS()) {
            titleStyle.height = properties.CLIPART_BUTTON_HEIGHT_OLD;
            spanStyle.top = 11;
            closeButtonStyle.top = 8;
        }

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{locales.getCaption('SaveMenuTitle', 'save')}</span>
                <button aria-label={locales.getCaption('close', 'other')} id="firstFocusableObject" style={closeButtonStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.dispatch(updateCurrentSlide());

        this.setSaveTitle();

        switch (this.props.index) {
            case 0: { // SAVE
                saveManager.saveData();
                break;
            }

            case 1: { // SAVE AS
                if (this.props.showSaveAsAlert)
                    saveManager.showSaveAsAlert = this.props.showSaveAsAlert;

                saveManager.saveAsData();
                break;
            }

            case 2: { // EXPORT
                animationManager.stopAnimations();
                saveManager.saveData();
                this.props.dispatch(showExportAlert(true));
                // exporterUtils.prepareDataForExport();
                break;
            }

            case 3: { // PRINT
                saveManager.saveData();

                setTimeout(function() {
                    window.open('/creaza/cartoonist/index.jsp?id=' + appParameters.contentItemId + '&cartoonistVersion=' + appParameters.bundleVersion + '&context=printEditor', '_blank');
                    this.props.dispatch(changeContextMode(modeType.CONTEXT_NONE));
                }.bind(this), 2000);
                break;
            }

            case 4: { // CANCEL
                this.props.dispatch(changeContextMode(modeType.CONTEXT_NONE));
                break;
            }
        }

        if (platformDetection.isIOS())
            document.activeElement.blur();
    },
    setSaveTitle() {
        var titleInput = document.getElementById('productionTitle');

        if (titleInput)
            appParameters.title = titleInput.value;
    },
    getSrc() {
        var icon;

        switch(this.props.index) {
            case 0: {
                icon = 'fa fa-floppy-o';
                break;
            }
            case 1: {
                icon = 'fa fa-clone';
                break;
            }
            case 2: {
                icon = 'fa fa-download';
                break;
            }
            case 3: {
                icon = 'fa fa-print';
                break;
            }
            case 4: {
                icon = 'fa fa-window-close-o';
                break;
            }
        }

        return icon;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth || this.props.isDisabled != newProps.isDisabled)
            return true;
        else
            return false;
    },
    render() {
        var textColor;
        var buttonColor;

        if (this.state.isOver == true) {
            textColor = properties.CONTEXT_HOVER_COLOR;
            buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
        } else {
            textColor = 'black';
            buttonColor = 'white';
        }

        var gap = 20;

        if (platformDetection.isIOS() == true)
            gap = 5;

        var buttonWidth = this.props.accordionWidth - 2 * gap;
        var buttonHeight = properties.TEXT_STYLING_BUTTON_HEIGHT + 10;
        var buttonIndex = this.props.index;

        var buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: buttonWidth,
            height: buttonHeight,
            display: 'flex',
            alignItems: 'center',
            left: gap,
            top: buttonIndex * (buttonHeight + 1),
            borderStyle: 'none',
            padding: 0,
            cursor: 'pointer'
        };

        var tabIndexValue = '';

        if (this.props.isDisabled) {
            buttonStyle.opacity = 0.5;
            buttonStyle.pointerEvents = 'none';
            tabIndexValue = '-1';
        }

        var iconStyle = {
            position: 'absolute',
            top: 14,
            left: 10,
            color: textColor,
            fontSize: 16
        };

        const padding = 35;
        const spanStyle = {
            color: textColor,
            fontSize: 15,
            position: 'absolute',
            top: 12,
            height: 20,
            width: buttonWidth - padding,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: padding
        };

        var iconElement;

        if (this.props.index == 2) {
            iconStyle.width = 18;
            var exportIcon = appParameters.RESOURCES_LOCATION() + 'assets/exportBtn.png';

            if (this.state.isOver)
                exportIcon = appParameters.RESOURCES_LOCATION() + 'assets/exportBtnHover.png';

            iconElement = <img alt='' aria-hidden='true' style={iconStyle} src={exportIcon}/>;
        } else
            iconElement = <i aria-hidden='true' style={iconStyle} className={this.getSrc()}></i>;

        var title = this.props.text;

        if (audioToolUtils.isAudioTool())
            title = title.replace('MP4', 'MP3');

        var idValue = this.props.index == 3 ? 'saveMenuLastFocusableElement' : undefined;

        return (
            <button tabIndex={tabIndexValue} id={idValue} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                {iconElement}
                <span style={spanStyle}>{title}</span>
            </button>
        );
    }
});

export const SaveMenu = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            isSaveAsAlert: false
        };
    },
    componentDidMount() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('firstFocusableObject');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onInputClick() {
        this.changeFocus();
    },
    changeFocus() {
        var view = this.refs.productionTitle;

        if (view) {
            view.focus();
        }
    },
    getTitleInputAriaLabel() {
        var view = this.refs.productionTitle;

        if (view)
            return view.value;
        else
            return appParameters.title;
    },
    onChangeText() {
        this.forceUpdate();
    },
    showSaveAsAlert() {
        this.setState({
            isSaveAsAlert: true
        });

        setInterval(this.closeSaveAsAlert.bind(this), 5000);
    },
    closeSaveAsAlert() {
        this.setState({
            isSaveAsAlert: false
        });
    },
    render() {
        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white'
        };

        var borderColor;
        var textColor;

        if (this.state.isOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            textColor = borderColor;
        } else {
            borderColor = 'black';
            textColor = 'black';
        }

        var fontSize = 16;
        var leftGap = properties.STYLING_LEFT_GAP;
        var inputPadding = 14;
        var inputTopPosition = 7;

        if (platformDetection.isIOS() == true) {
            leftGap = 4;
            fontSize = 14;
            inputPadding = 9;
            inputTopPosition = 3;
        }

        var titleWidth = this.props.accordionWidth - 2 * leftGap;

        const titleStyle = {
            width: titleWidth,
            height: properties.TEXT_STYLING_BUTTON_HEIGHT,
            background: 'white',
            borderRadius: 50,
            position: 'absolute',
            left: leftGap,
            top: properties.CLIPART_BUTTON_HEIGHT + properties.STYLING_TOP_GAP,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            alignItems: 'center'
        };

        const inputStyle = {
            position: 'absolute',
            color: textColor,
            top: inputTopPosition,
            paddingLeft: inputPadding,
            fontSize: fontSize,
            width: titleWidth - 2 * inputPadding,
            resize: 'none',
            overflow: 'hidden',
            border: 'none',
            outline: 'none',
            background: 'transparent'
        };

        const buttonsHolderStyle = {
            position: 'absolute',
            top: properties.CLIPART_BUTTON_HEIGHT + 2 * properties.STYLING_TOP_GAP + properties.TEXT_STYLING_BUTTON_HEIGHT
        };

        const fillOutFieldViewWidth = 150;
        var fillOutFieldViewStyle = {
            position: 'absolute',
            background: '#434343',
            width: fillOutFieldViewWidth,
            height: 30,
            top: 45,
            left: 20,
            borderRadius: 5,
            zIndex: 99999,
            pointerEvents: 'none'
        };

        const stemStyle = {
            position: 'absolute',
            borderWidth: 10,
            borderStyle: 'solid',
            borderBottomColor: '#434343',
            borderTopColor: 'transparent',
            borderLeftColor: 'transparent',
            borderRightColor: 'transparent',
            top: -20,
            left: fillOutFieldViewWidth/2 - 10
        };

        const captionStyle = {
            position: 'absolute',
            color: 'white',
            wordWrap: 'break-word',
            textAlign: 'center',
            fontSize: 12,
            left: 5,
            top: 8,
            width: fillOutFieldViewWidth - 10
        };

        var fillOutFieldView;
        var isDisabled = false;
        var isEmptyTitle = this.refs.productionTitle && this.refs.productionTitle.value.length < 1;

        if (isEmptyTitle || this.state.isSaveAsAlert) {
            var alertText = isEmptyTitle ? locales.getCaption('FillOutThisField', 'other') : locales.getCaption('TheCopyHasBeenDone', 'other');

            if (this.state.isSaveAsAlert)
                fillOutFieldViewStyle.top = 145;

            fillOutFieldView =
                <div style={fillOutFieldViewStyle}>
                    <div style={stemStyle}></div>
                    <div style={captionStyle}>
                        {alertText}
                    </div>
                </div>;

            if (isEmptyTitle)
                isDisabled = true;
        }

        return (
            <div style={menuStyle} id="saveMenu">
                <Title accordionWidth={this.props.accordionWidth}/>
                <div style={titleStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onInputClick}>
                    <input type='text' aria-label={this.getTitleInputAriaLabel()} ref='productionTitle' id='productionTitle' className='titleInput' onChange={this.onChangeText} style={inputStyle} defaultValue={appParameters.title} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off'/>
                    {fillOutFieldView}
                </div>
                <div style={buttonsHolderStyle}>
                    <Button accordionWidth={this.props.accordionWidth} isDisabled={isDisabled} index={0} dispatch={this.props.dispatch} text={locales.getCaption('Save', 'save')}/>
                    <Button showSaveAsAlert={this.showSaveAsAlert} accordionWidth={this.props.accordionWidth} isDisabled={isDisabled} index={1} dispatch={this.props.dispatch} text={locales.getCaption('SaveAs', 'save')}/>
                    <Button accordionWidth={this.props.accordionWidth} index={2} dispatch={this.props.dispatch} text={locales.getCaption('Export', 'save')}/>
                    <Button accordionWidth={this.props.accordionWidth} index={3} dispatch={this.props.dispatch} text={locales.getCaption('Print', 'save')}/>
                    <Button accordionWidth={this.props.accordionWidth} index={4} dispatch={this.props.dispatch} text={locales.getCaption('Cancel', 'save')}/>
                </div>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/SaveMenu.js
 **/